import {css} from "@emotion/react";
import {Input, OutlinedInput} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import React from "react";

interface StyledInputProps {
    color?: string;
    disabled?: boolean;
    value?: string;
    marginBottom?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function StyledInput({color, disabled, value, marginBottom, onChange}: StyledInputProps) {

    const theme = useTheme();

    return (
        <OutlinedInput
            onChange={onChange}
            value={value}
            disabled={disabled}
            sx={{
                borderRadius: theme.border.radius.md,
                marginBottom: marginBottom,



                // Bordi di base
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.white,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.orange,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.orange,
                },
                color: color,

                // Stato disabilitato
                "&.Mui-disabled": {
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent", // bordo da disabilitato
                    },
                    "& .MuiInputBase-input": {
                        color: "white",       // testo da disabilitato
                        WebkitTextFillColor: "white", // serve per Safari
                    },
                },
            }}
        />
    )
}